<app-message></app-message>
<app-menu ></app-menu>
<app-loader></app-loader>
<router-outlet></router-outlet>
